// @core/api/endpoints/booking/get_effective_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingPolicyResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get effective policy
 * Returns the merged effective policy for a resource (type defaults + resource overrides).
 */
export async function GetEffectivePolicy(
  resource_id: string,
  options?: RequestOptions
): Promise<BookingPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/policy`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<BookingPolicyResponse>(requestPath, { ...requestOptions });
}
